module.exports = __webpack_public_path__ + "img/more-menu.edf69eeb.svg";